import { render, staticRenderFns } from "./addReserveParams.vue?vue&type=template&id=4d099f4e"
import script from "./addReserveParams.vue?vue&type=script&lang=js"
export * from "./addReserveParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports